import { useTranslations } from 'use-intl';
import { OnboardingStep } from '../OnboardingStep';
import { useNavigate, useParams } from 'react-router-dom';
import { routes } from '@blockpulse3/data/shared';
import { Button } from '@chakra-ui/react';
import { StepFormContextProvider } from '../../provider';
import { ExistingCompanyParameters } from '../forms';

type Props = unknown;

/**
 * OnboardingExistingCompanyParameters.
 * Existing company informations, update step.
 *
 * @returns {JSX.Element}
 */
export function OnboardingExistingCompanyParameters(): JSX.Element {
  const i18nGeneral = useTranslations('General');
  const i18nCompanyInformationsForm = useTranslations('CompanyInformationsForm');

  const navigate = useNavigate();

  const { companyId = '' } = useParams();

  const handleStepSubmit = (): void => {
    navigate(routes.onboardings.company.representatives.fmt(companyId));
  };

  return (
    <StepFormContextProvider>
      <OnboardingStep
        subTitle={i18nCompanyInformationsForm('FormSubTitle')}
        title={i18nCompanyInformationsForm('FormTitle')}
      >
        <ExistingCompanyParameters onSubmit={handleStepSubmit} />
        <Button form="company-informations" type="submit" w="full">
          {i18nGeneral('Submit')}
        </Button>
      </OnboardingStep>
    </StepFormContextProvider>
  );
}

export type OnboardingExistingCompanyParametersProps = Props;
